
import nodata from "../../Utils/assets/img/leads_no_data_found_removebg.png"
import { useEffect, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import useLocalStorageState from "use-local-storage-state"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { Kanban } from "../../Utils/kanban/Kanban"
import { IconArrowRight } from "@tabler/icons-react"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import DeleteModal from "../DeleteModal"
import {
  DeleteRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import { toast } from "sonner"
import { components } from "react-select"
import { CreateDeal } from "./CreateDeal"
import { UpdateDeal } from "./UpdateDeal"
import { DealDetails } from "./DealDetails"
import { usePermissions } from "../../Utils/helpers/commonhelper"
import { AuthorizationCard } from "../../pages/AuthorizationCard"
import { EditPipelinePage } from "../PipelineComponents/EditPipelinePage"
import { CreatePipelinePage } from "../PipelineComponents/CreatePipelinePage"
import { DealHeader } from "./DealHeader"
// Utility function for encoding pipeline IDs for URL parameters
const encodePipelineId = (id) => {
  const base64 = btoa(id.toString())
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}
//menulist for add new products and services button in dropdown
const MenuList = (props) => {
  return (
    <>
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            padding: "10px",
            borderTop: "1px solid #ddd",
            textAlign: "center",
            cursor: "pointer",
            color: "#2184ff",
            fontSize: "0.9rem",
          }}
          onClick={() => {
            // trigger your modal open here
            props.selectProps.onAddNew()
          }}
        >
          + Create Pipeline
        </div>
      </components.MenuList>
    </>
  )
}

export const Deals = () => {
  // to determine the state being passed from leads when a lead is being converted to a won state
  const location = useLocation();
  // the state contains the id of the lead that's being converted to won state
  const state = location.state || null;

  // let idFromDashboard = state?.id || null
  const [initialDashboardPipelineId, setInitialDashboardPipelineId] = useState(state?.id || null)
  // State management for pipelines, stages, and leads
  const [pipedLines, setPipelines] = useState([])
  const [selectedPipelineId, setSelectedPipelineId] = useState(null)
  const [pipelineStages, setPipelineStages] = useState([])
  const [dealsData, setDealsData] = useState([])
  const [refetchDealsData, setrefetchDealsData] = useState(false)
  // Form modal states
  const [showCreateDeal, setShowCreateDeal] = useState(false)
  const [showUpdateDeal, setShowUpdateDeal] = useState(false)
  // const [showFollowUp, setShowFollowUp] = useState(false)
  const [showDealDetails, setShowDealDetails] = useState(false)
  const [selectedDealId, setSelectedDealId] = useState(null)
  const [editDealId, setEditDealId] = useState(null)
  // const [followUpDealId, setFollowUpDealId] = useState(null)
  const [selectedStageId, setSelectedStageId] = useState(null)
  const [settingsDropdown, setSettingsDropdown] = useState(false)
  // Delete confirmation states
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteDealId, setDeleteDealId] = useState(null)
  const [showPipelineDeleteModal, setShowPipelineDeleteModal] = useState(false)
  const [pipelineToDelete, setPipelineToDelete] = useState(null)

  //delete modal loading state
  const [isDeleting, setIsDeleting] = useState(false)

  // // Search states for debounced search
  const [debouncedSearch, setDebouncedSearch] = useState("")

  // Pagination states for list view
  const [limit, setLimit] = useState(25)
  const [listOffset, setListOffset] = useState(0)
  const [cardOffset, setCardOffset] = useState(0)

  // Local storage for view settings
  const [currView, setCurrView] = useState(() => {
    return localStorage.getItem("dealsView") || "card"
  })

  const activeOffset = currView === "card" ? cardOffset : listOffset
  const setActiveOffset =
    currView === "card" ? setCardOffset : setListOffset

  // Filter type state with localStorage persistence
  const [currentFilterType, setCurrentFilterType] = useState(() => {
    return localStorage.getItem("dealsFilterType") || "all"
  })

  const [editPipeline, setEditPipeline] = useState(false)
  const [encodedId, setEncodedId] = useState(null)
  const [createPipeline, setCreatePipeline] = useState(false)

  // Session storage and authentication setup
  const [customer, setCustomer] = useLocalStorageState("customer")
  const navigate = useNavigate()
  const customerId = customer?.customer_details?.customer_id
  const loginUserId = customer?.customer_details?.id
  const token = customer?.token?.authorization
  const rf = customer?.token?.authentication

  // Tab focus tracking for handling tab switches
  const [isTabVisible, setIsTabVisible] = useState(true)
  const [forceRefetch, setForceRefetch] = useState(0)
  const mountedRef = useRef(true)

  // permission setup for conntacts
  const permission = customer.customer_details?.permission
  // permission for lead and deal
  const dealPermission = permission?.filter(c => c.module_name === "deals")
  const user_type = Number(customer.customer_details?.user_type)
  const dealGrant = {
    isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "export")?.is_action)) : true,
  }
  const followupGrant = {
    isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
  }

  // after completing won deal to show that deal in a blinking state
  useEffect(() => {
    if (!state) return
    setSelectedPipelineId(state?.pipelineId)
    setHighlightId(state.id);

  }, [state]);

  const columnOptions = [
    { id: "contact_full_name", label: "Name", mandatory: true },
    { id: "email", label: "Email" },
    { id: "contact_phone", label: "Phone" },
    { id: "requirement", label: "Requirement" },
    { id: "pipeline_stage_name", label: "Pipeline Stage Name" },
    { id: "lead_status", label: "Lead Status" },
    { id: "budget", label: "Budget" },
    { id: "source_title", label: "Source" },
    { id: "expected_closure_date", label: "Expected Closure Date" },
  ]

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("dealsVisibleColumns");
    const allColumns = columnOptions.map(col => col.label);

    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }

    // Default: all columns visible
    return allColumns;
  });

  // Filter states
  const [filterStates, setFilterState] = useState([])
  const [filteredLeads, setFilteredLeads] = useState(null)


  const [endpoint, setEndpoint] = useState("")
  const [queryKey, setQueryKey] = useState("")

  // // state for heading to display
  // const lastHeading = localStorage.getItem("deals_last_heading")
  const [heading, setHeading] = useState("All Deals")
  // // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])
  // for storing the parsed shared users to pass down to the pipeline share model where i will render these users with their respective permissions corresponding to that pipeline
  const [parsedSharedUsers, setParsedSharedUsers] = useState(null)

  // variable for query params
  const [searchParams, setSearchParams] = useSearchParams()
  const moduleName = searchParams.get("module")
  const moduleId = searchParams.get("id")

  //state to blink latest deal
  const [highlightId, setHighlightId] = useState(null)
  // API headers configuration
  const headers = {
    Authentication: rf,
    Authorization: token,
  }

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  }

  // Track tab visibility and handle refetch on focus
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = !document.hidden
      setIsTabVisible(isVisible)

      if (isVisible && mountedRef.current) {
        // Force refetch when tab becomes visible again
        setTimeout(() => {
          setForceRefetch((prev) => prev + 1)
        }, 100)
      }
    }

    const handleFocus = () => {
      if (mountedRef.current) {
        setIsTabVisible(true)
        setTimeout(() => {
          setForceRefetch((prev) => prev + 1)
        }, 100)
      }
    }

    const handleBlur = () => {
      setIsTabVisible(false)
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    window.addEventListener("focus", handleFocus)
    window.addEventListener("blur", handleBlur)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      window.removeEventListener("focus", handleFocus)
      window.removeEventListener("blur", handleBlur)
    }
  }, [])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      mountedRef.current = false
    }
  }, [])

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("dealsView", currView)
  }, [currView])

  // Save visible columns to localStorage
  useEffect(() => {
    localStorage.setItem("dealsVisibleColumns", JSON.stringify(columns))
  }, [columns])

  // Save filter type to localStorage
  useEffect(() => {
    localStorage.setItem("dealsFilterType", currentFilterType)
  }, [currentFilterType])

  // Fetch all pipelines for the customer
  const {
    data: pipelineData,
    isLoading: isPipelineLoading,
    refetch: refetchPipeline,
  } = useGetRequest(
    `lead/fetchPipelines/${customerId}/deals/${loginUserId}/${customer.customer_details?.user_type}`,
    ["fetchDealsPipeline", forceRefetch],
    headers,
    extras,
    {}
  )

  useEffect(() => {
    if (pipelineData?.status === "success") {
      const fetchedPipelines = pipelineData.data || []
      setPipelines(fetchedPipelines)

      if (initialDashboardPipelineId !== null && selectedPipelineId === null) {
        setSelectedPipelineId(initialDashboardPipelineId)
        setInitialDashboardPipelineId(null)
        return
      }

      if (
        !selectedPipelineId ||
        !fetchedPipelines.some((p) => p.id === selectedPipelineId)
      ) {
        if (fetchedPipelines.length > 0) {
          const selectpipe =
            fetchedPipelines.find((el) => el.is_active === "yes") ||
            fetchedPipelines[0]

          setSelectedPipelineId(selectpipe.id)
        }
      }
    }
  }, [pipelineData])

  const pipelineStageUrl = selectedPipelineId
    ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`
    : null

  // Fetch pipeline stages for selected pipeline
  const {
    data: pipelineStageData,
    isLoading: isPipelineStageLoading,
    refetch: refetchPipelineStage,
  } = useGetRequest(
    pipelineStageUrl,
    ["fetchPipelineStage", selectedPipelineId, forceRefetch],
    headers,
    extras,
    {
      enabled: !!selectedPipelineId && isTabVisible,
    }
  )
  // Handle pipeline stage data updates and formatting
  useEffect(() => {
    if (pipelineStageData?.status === "success") {
      const formattedStages = pipelineStageData.data.map((stage) => ({
        ...stage,
        stage_id: stage.id,
        sequence: String(stage.sequence),
        probability: Math.min(100, stage.probability || 0),
        rotting_days: stage.rotting_days === null ? null : stage.rotting_days,
        rotting_enabled: stage.rotting_days !== null && stage.rotting_days > 0,
      }))
      setSelectedStageId(formattedStages[0]?.id)
      setPipelineStages(formattedStages)
    } else if (pipelineStageData?.status === "fail") {
      setPipelineStages([])
      if (pipelineStageData.message) {
        toast.error(pipelineStageData.message)
      }
    }
  }, [pipelineStageData, heading])
  // Create params object
  const dealsParams = {}
  if (currView === "list") {
    dealsParams.limit = limit
    dealsParams.offset = activeOffset
  }
  if (debouncedSearch) {
    dealsParams.search = debouncedSearch
  }

  useEffect(() => {
    if (!selectedPipelineId) return
    // fetching contacts based on header
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading
    if (lowerHeading === "deals_created_by_me") {
      setEndpoint(
        `deals/dealsCreatedByMe/${loginUserId}/${customerId}/${selectedPipelineId}/${customer.customer_details?.user_type}/${currView}`
      )
      setQueryKey("dealsCreatedByMe")
    } else if (lowerHeading === "deals_created_today") {
      setEndpoint(
        `deals/getDealsCreatedBasedOnDuration/${customerId}/today/${selectedPipelineId}/${customer?.customer_details?.id}/${customer.customer_details?.user_type}/${currView}`
      )
      setQueryKey("dealsCreatedToday")
    } else if (lowerHeading === "deals_created_this_month") {
      setEndpoint(
        `deals/getDealsCreatedBasedOnDuration/${customerId}/month/${selectedPipelineId}/${customer?.customer_details?.id}/${customer.customer_details?.user_type}/${currView}`
      )
      setQueryKey("dealsCreatedThisMonth")
    } else if (lowerHeading === "my_today_followup") {
      setEndpoint(
        `deals/fetchDealsBasedOnTodaysFollowup/${customerId}/month/${selectedPipelineId}/${customer?.customer_details?.id}/${customer.customer_details?.user_type}/${currView}/filter_card_id=null`
      )
      setQueryKey("mytodayfollowup")
    } else if (lowerHeading === "all_deals") {
      if (moduleName === "contact") {
        setEndpoint(
          `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${customer.customer_details?.user_type}/${currView}?module=contact&id=${moduleId}`
        )
        setQueryKey("fetchContactDeals")
      } else if (moduleName === "company") {
        setEndpoint(
          `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${customer.customer_details?.user_type}/${currView}?module=company&id=${moduleId}`
        )
        setQueryKey("fetchCompanyDeals")
      } else {
        setEndpoint(
          `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${customer.customer_details?.user_type}/${currView}`
        )
        setQueryKey("fetchAllDeals")
      }
    } else {
      const matchedCategory = filterCategories.find((category) => {
        return category.card_name === heading
      })
      if (matchedCategory) {
        setEndpoint(
          `deals/fetchDeals/${customerId}/${selectedPipelineId}/${customer?.customer_details?.id}/${customer.customer_details?.user_type}/${currView}/${matchedCategory.id}`
        )
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        )
      }
    }
  }, [heading, filterCategories, selectedPipelineId, currView])

  const {
    data: dealsApiData,
    isLoading: isDealsLoading,
    refetch: refetchDeals,
  } = useGetRequest(
    endpoint,
    [
      queryKey,
      selectedPipelineId,
      currentFilterType,
      forceRefetch,
      activeOffset,
      limit,
      debouncedSearch,
    ],
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    {
      ...dealsParams,
      enabled: !!selectedPipelineId && isTabVisible && currView,
    }
  )
  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    const sharedUsers = dealsApiData?.pipeline_data?.["shared_to"]
    setParsedSharedUsers(JSON.parse(sharedUsers !== undefined && sharedUsers))

    setDealsData(dealsApiData?.data?.map(stage => ({
      ...stage,
      leads: stage.leads?.map(deal => ({
        ...deal,
        product_services: typeof deal.product_services === "string"
          ? (() => {
            try {
              return JSON.parse(deal.product_services)
            } catch {
              return deal.product_services
            }
          })()
          : deal.product_services
      }))
    })))

  }, [queryKey, dealsApiData])


  // hook for getting the permissions assigned to the user
  const { permissionAssigned, canEdit_canDownload } = usePermissions(
    customer,
    parsedSharedUsers,
    dealsApiData
  )
  useEffect(() => {
    if (!selectedPipelineId) return;

    if (currView === "list") {
      setActiveOffset(0);
    }

    const timer = setTimeout(() => {
      setForceRefetch(prev => prev + 1);
    }, 100);

    return () => clearTimeout(timer);
  }, [currView, selectedPipelineId]);

  // Force refetch when tab becomes visible and data is stale
  useEffect(() => {
    if (isTabVisible && selectedPipelineId && forceRefetch > 0) {
      const timer = setTimeout(() => {
        refetchDeals()
        refetchPipelineStage()
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [
    forceRefetch,
    isTabVisible,
    selectedPipelineId,
    refetchDeals,
    refetchPipelineStage,
  ])

  // Enhanced pipeline change handling
  useEffect(() => {
    if (!selectedPipelineId) return

    // Clear dependent data immediately
    setPipelineStages([])
    setSelectedStageId(null)
    setShowCreateDeal(false)
    // setShowFollowUp(false)
    setSelectedDealId(null)
    setShowDealDetails(false)

    // Trigger refetch with a delay to ensure clean state
    const timer = setTimeout(() => {
      setForceRefetch((prev) => prev + 1)
    }, 50)

    return () => clearTimeout(timer)
  }, [selectedPipelineId])

  // Update lead stage with optimistic UI updates
  const handleUpdateLead = async (leadData, newStageId, oldStageId) => {
    const originalDealsData = [...dealsData]
    // Optimistically update UI
    setDealsData((prev) => {
      const newData = [...prev]

      const oldStageIndex = newData.findIndex(
        (stage) => stage.stage_id === oldStageId
      )
      if (oldStageIndex !== -1) {
        newData[oldStageIndex] = {
          ...newData[oldStageIndex],
          leads: newData[oldStageIndex].leads.filter(
            (lead) => lead.lead_id !== leadData.lead_id
          ),
        }
      }

      const newStageIndex = newData.findIndex(
        (stage) => stage.stage_id === newStageId
      )
      if (newStageIndex !== -1) {
        newData[newStageIndex] = {
          ...newData[newStageIndex],
          leads: [...newData[newStageIndex].leads, leadData],
        }
      }

      return newData
    })
    const selectedPipeline = pipedLines.find((p) => p.id === selectedPipelineId)
    const updatePayload = {
      customer_id: customer.customer_details?.customer_id,
      user_login_id: loginUserId,
      deal_id: leadData.lead_id,
      contact_id: leadData.contact_id,
      pipeline_id: selectedPipeline.id,
      pipeline_stage_id: newStageId,
      expected_closure_date: leadData.expected_closure_date,
      expected_closure_time: leadData.expected_closure_time,
      requirement: leadData.requirement,
      product_services: leadData.product_services,
      budget: leadData.budget,
      lead_source_id: leadData.lead_source_id,
      deal_name: leadData.deal_name,
      currency_id: leadData.currency_id,
      owner_id: leadData.owner_id
    }

    try {
      const response = await PutRequest(
        `deals/updateDeal`,
        updatePayload,
        { headers },
        extras
      )

      if (response?.status === "success") {
        toast.success(response.message || "Lead updated successfully")
        await refetchDeals()
      } else {
        toast.error(response?.message || "Failed to update lead")
        setDealsData(originalDealsData)
      }
    } catch (error) {
      toast.error(error.message || "Failed to save lead")
      setDealsData(originalDealsData)
    }
  }

  // Confirm and execute pipeline deletion
  const handlePipelineDeleteConfirm = async () => {
    if (!pipelineToDelete) return
    setIsDeleting(true)
    try {
      const response = await DeleteRequest(
        `lead/deletePipeline/${pipelineToDelete}/${customerId}/${customer.customer_details?.id}`,
        { headers },
        extras
      )
      if (response?.status === "success") {
        toast.success("Pipeline deleted successfully")
        setShowPipelineDeleteModal(false)
        setPipelineToDelete(null)
        setIsDeleting(false)
        await refetchPipeline()
        navigate(`/deals`)
      } else {
        toast.error(response?.message || "Failed to delete pipeline")
        setIsDeleting(false)
      }
    } catch (error) {
      toast.error("An error occurred while deleting pipeline")
      setIsDeleting(false)
    }
  }

  // Open add lead form
  const handleAddDeal = (stageId = null) => {
    if (!dealGrant?.isCreate || !canEdit_canDownload) {
      toast.warning("You are not authorised for this action!")
      return
    }
    setSelectedStageId(stageId)
    setEditDealId(null)
    setShowCreateDeal(true)
  }

  // Open edit lead form with specific lead ID
  const handleEditLead = (leadId) => {
    setEditDealId(leadId)
    setSelectedStageId(null)
    setShowUpdateDeal(true)
  }

  // Open follow up form for specific lead
  // const handleFollowUpLead = (leadId) => {
  //   setFollowUpDealId(leadId)
  //   // setShowFollowUp(true)
  // }

  // Show delete confirmation modal for lead
  const handleDeleteDeal = (leadId) => {
    setDeleteDealId(leadId)
    setShowDeleteModal(true)
  }

  // Open lead details modal with proper lead ID
  const handleOpenDealDetails = (lead) => {
    setShowDealDetails(false)
    setSelectedDealId(null)

    setTimeout(() => {
      setSelectedDealId(lead.lead_id)
      setShowDealDetails(true)
    }, 50)
  }

  // Close lead details and refresh data
  const handleCloseDealDetails = () => {
    setShowDealDetails(false)
    setSelectedDealId(null)
    setrefetchDealsData(true)
    setIsDeleting(false)
  }

  // Confirm and execute lead deletion
  const handleDeleteConfirm = async () => {
    setIsDeleting(true)
    try {
      const response = await DeleteRequest(
        `deals/deleteDeal/${deleteDealId}/${customer.customer_details?.id}`,
        { headers },
        extras
      )

      if (response?.status === "success") {
        toast.success(response.message)
        setIsDeleting(false)
        await refetchDeals()
      } else {
        toast.error(response?.message || "Failed to delete Deal")
        setIsDeleting(false)
      }
    } catch (error) {
      toast.error("An error occurred while deleting deal")
      setIsDeleting(false)
    } finally {
      setShowDeleteModal(false)
      setDeleteDealId(null)
      setIsDeleting(false)
    }
  }

  // Close delete confirmation modal
  const handleDeleteClose = () => {
    setShowDeleteModal(false)
    setDeleteDealId(null)
  }

  // Refresh leads after follow up update
  // const handleFollowUpUpdated = () => {
  //   refetchDeals()
  // }

  // Close create lead form and reset selection
  const handleCreateDealClose = () => {
    setShowCreateDeal(false)
    setSelectedStageId(null)
  }

  const handleUpdateDealClose = () => {
    setShowUpdateDeal(false)
    setSelectedStageId(null)
  }

  // Pagination handlers
  const handlePageChange = (selectedPage) => {
    setActiveOffset(selectedPage.selected)
  }

  // Enhanced refetch handling
  useEffect(() => {
    if (refetchDealsData && isTabVisible) {
      refetchDeals()
      setrefetchDealsData(false)
    }
  }, [refetchDealsData, refetchDeals, isTabVisible])

  // Calculate pagination values
  const totalContacts = dealsApiData?.total_count || 0
  const pageCount = Math.ceil(totalContacts / limit)

  const selectedPipeline = pipedLines.find((p) => p.id === selectedPipelineId)

  // Combine permanent and visible columns for display
  // const allVisibleColumns = [...permanentFields, ...visibleColumns]

  // Enhanced loading state and data ready check
  const isDataReady =
    selectedPipeline &&
    pipelineStages.length > 0 &&
    !isPipelineStageLoading &&
    !isDealsLoading
  if (createPipeline) {
    return (
      <CreatePipelinePage
        module_name="deal"
        refetchPipelineData={refetchPipeline}
        setCreatePipeline={setCreatePipeline}
        setSelectedPipelineId={setSelectedPipelineId}
      />
    )
  }

  if (editPipeline && encodedId) {
    return (
      <EditPipelinePage
        encodedId={encodedId}
        module_name="deal"
        refetch={refetchPipeline}
        refetchPipelineStage={refetchPipelineStage}
        setEditPipeline={setEditPipeline}
        pipelineCount={pipedLines.length}
      />
    )
  }
  return (
    <>

      <DealHeader
        currView={currView}
        setCurrView={setCurrView}
        columns={columns}
        setColumns={setColumns}
        columnOptions={columnOptions}
        permissionAssigned={permissionAssigned}
        canEdit_canDownload={canEdit_canDownload}
        dealGrant={dealGrant}
        currentFilterType={currentFilterType}
        heading={heading}
        setHeading={setHeading}
        parsedSharedUsers={parsedSharedUsers}
        setActiveOffset={setActiveOffset}
        dealsData={dealsData}
        handleAddDeal={handleAddDeal}
        selectedPipelineId={selectedPipelineId}
        setSelectedPipelineId={setSelectedPipelineId}
        pipedLines={pipedLines}
        pipelineStages={pipelineStages}
        encodePipelineId={encodePipelineId}
        debouncedSearch={debouncedSearch}
        setDebouncedSearch={setDebouncedSearch}
        filterCategories={filterCategories}
        setFilterCategories={setFilterCategories}
        selectedPipeline={selectedPipeline}
        filterStates={filterStates}
        setFilterState={setFilterState}
        setEncodedId={setEncodedId}
        setCreatePipeline={setCreatePipeline}
        selectedStageId={selectedStageId}
        setEditPipeline={setEditPipeline}
        dealsApiData={dealsApiData}
        setTempFilterData={setTempFilterData}
      />
      {/* Enhanced loading state with better UX */}
      {
        (isPipelineStageLoading || isDealsLoading) && dealGrant?.isView && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )
      }

      {/* Enhanced condition for showing "No data" state */}
      {
        !isDataReady && !isPipelineStageLoading && !isDealsLoading && selectedPipelineId && isTabVisible && dealGrant?.isView && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
            <div className="text-center">
              <div
                class="d-flex justify-content-center align-items-center"
              >
                <img
                  src={nodata}
                  alt=""
                  style={{ width: "17rem", marginTop: "0" }}
                />
              </div>
              <Button
                onClick={() => {
                  const encodedId = encodePipelineId(selectedPipelineId)
                  setEncodedId(encodedId)
                  setEditPipeline(true)
                }}
                className="btn-sm btn-default"
              >
                Create Stage <IconArrowRight size={14} stroke={2} />
              </Button>
            </div>
          </div>
        )
      }
      {
        pipedLines.length === 0 && !isPipelineLoading && !isPipelineStageLoading && dealGrant?.isView &&
        <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
          <div className="text-center">
            <p>No data available</p>
            <Button
              variant="outline-primary"
              onClick={() => {
                if (!dealGrant?.isCreate) {
                  toast.warning("You are not authorized for this action!")
                  return
                }
                setCreatePipeline(true)
              }}
              className="btn-sm btn-default"
            >
              Create Your first Pipeline
            </Button>
          </div>
        </div>
      }
      {/* Kanban board - Enhanced rendering logic */}
      {
        dealGrant?.isView ?
          isDataReady && (
            <Kanban
              tempFilterData={tempFilterData}
              canEdit_canDownload={canEdit_canDownload}
              stages={pipelineStages}
              leadsData={dealsData}
              setLeadsData={setDealsData}
              onUpdateLead={handleUpdateLead}
              onAddLead={handleAddDeal}
              onEditLead={handleEditLead}
              // onFollowUpLead={handleFollowUpLead}
              onDeleteLead={handleDeleteDeal}
              currView={currView}
              visibleColumns={columns}
              filteredLeads={filteredLeads}
              onOpenLeadDetails={handleOpenDealDetails}
              offset={activeOffset}
              limit={limit}
              pageCount={pageCount}
              handlePageChange={handlePageChange}
              setOffset={setActiveOffset}
              setLimit={setLimit}
              mainGrant={dealGrant}
              followupGrant={followupGrant}
              headers={headers}
              extras={extras}
              module_name={'deal'}
              highlightId={highlightId}
            />
          )
          :
          <AuthorizationCard />
      }

      {/* Create/Edit Lead Modal */}
      <CreateDeal
        show={showCreateDeal}
        onHide={handleCreateDealClose}
        setDealClose={setShowCreateDeal}
        editId={editDealId}
        stageId={selectedStageId}
        pipelineId={selectedPipelineId}
        refetchDeals={refetchDeals}
        moduleName="deal"
      />
      <UpdateDeal
        show={showUpdateDeal}
        onHide={handleUpdateDealClose}
        editId={editDealId}
        refetchDeals={refetchDeals}
      />

      <DealDetails
        show={showDealDetails}
        canEdit_canDownload={canEdit_canDownload}
        setrefetchDealsData={setrefetchDealsData}
        onClose={handleCloseDealDetails}
        dealId={selectedDealId}
        pipelineStageData={pipelineStageData}
        refetchDeals={refetchDeals}
        isLoading={isDeleting}
        setIsLoading={setIsDeleting}
        setSelectedStageId={setSelectedStageId}
      />

      {/* Delete Lead Confirmation Modal */}
      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
        isLoading={isDeleting}
        message="Are you sure you want to delete this lead?"
      />

      {/* Pipeline Delete Confirmation Modal */}
      <DeleteModal
        show={showPipelineDeleteModal}
        onClose={() => {
          setShowPipelineDeleteModal(false)
          setPipelineToDelete(null)
        }}
        onConfirm={handlePipelineDeleteConfirm}
        isLoading={isDeleting}
        message="Are you sure you want to permanently delete this pipeline?"
      />
    </>
  )
}
